import { ReturnsPromise } from 'api/api';

import { TranslateICUFn } from '~src/commons/utils/translations/translate';

/**
 * Builds the appropriate title for the Return and Exchange section
 * based on which options are available
 */
export const titleBuilder = (
  translate: TranslateICUFn,
  returnsPromise: ReturnsPromise
): string | null => {
  const { returns_enabled, exchanges_enabled } = returnsPromise;

  if (!returns_enabled && !exchanges_enabled) {
    return null;
  }

  // Only return is offered
  if (returns_enabled && !exchanges_enabled) {
    return translate('widget.RETURNS_POLICY.RETURN_TITLE');
  }

  // Only exchange is offered
  if (!returns_enabled && exchanges_enabled) {
    return translate('widget.RETURNS_POLICY.EXCHANGE_TITLE');
  }

  // Both exchange & return are offered
  return translate('widget.RETURNS_POLICY.EXCHANGE_AND_RETURN_TITLE');
};
